/**
 * Build-time configuration. Vite inlines `import.meta.env.VITE_*` at build, so
 * every value here is fixed per deploy. Empty strings mean "off".
 *
 * Each variable is read by its full name on purpose: touching
 * `import.meta.env` as a whole object makes Vite inline EVERY `VITE_*`
 * variable into the bundle — including dev-only secrets from `.env.local`.
 */
const clean = (value: string | undefined): string => (typeof value === 'string' ? value.trim() : '');

/** The dev server opened through a tunnel (ngrok): the API is reached through it too, at `/__api` (vite.config.ts). */
const viaTunnel = (): boolean => import.meta.env.DEV && typeof window !== 'undefined' && !/^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);

export const env = {
  backendUrl: viaTunnel() ? `${window.location.origin}/__api` : (clean(import.meta.env.VITE_BACKEND_URL) || 'http://localhost:8080').replace(/\/+$/, ''),
  posthogToken: clean(import.meta.env.VITE_POSTHOG_TOKEN),
  posthogHost: clean(import.meta.env.VITE_POSTHOG_HOST),
  sentryDsn: clean(import.meta.env.VITE_SENTRY_DSN),
  isProd: import.meta.env.PROD,
} as const;
